import cloneDeep from 'lodash/cloneDeep';
import startsWith from 'lodash/startsWith';
import identify from "~/identify";

export const getActivatedMenu = (givenMenu, props) => {
    givenMenu = cloneDeep(givenMenu);

    const setModelActive = (menu, props) => {
        let {modelName = null, activeAppBarDialog = null, tooltipsActive = false, trans} = props;

        for(let item of menu) {
            item.label = item.label ? trans(item.label) : item.label;
            item.tooltip = item.tooltip && tooltipsActive ? trans(item.tooltip) : null;
            item.active = modelName && startsWith(modelName, item.value);
            item.activeAppBarDialog = activeAppBarDialog && activeAppBarDialog === item.value;
            
            if(item.children) {
                item.children = setModelActive(item.children, props);
            }
        }

        return menu;
    };

    return setModelActive(givenMenu, props);
};

export const filterMenu = (menu, props) => {
    menu = cloneDeep(menu);
    let {onlyType, excluded} = props;

    return menu.filter((item) => {
      if(onlyType && item.type && item.type !== onlyType) {
          let a = 4;
          return false
      }
      if(excluded && item.value && excluded.indexOf(item.value) > -1) {
          return false;
      }

      if(item.children && item.children.length) {
          item.children = filterMenu(item.children, props);
      }

      return true;
    });
};